module.exports = __webpack_public_path__ + "img/listbg.12b6c24a.png";